import { useLang } from '@/i18n';
import HightlightTextAni from '../HighlightTextAni';
import { useRouter } from 'next/router';

const E: React.FC = () => {
    const { t } = useLang('dpux');
    const { locale = '' } = useRouter();
    return <HightlightTextAni id={'delta-pro-ultra-x-E'} title={t('E_title')} desc={t('E_desc')} footer={locale === 'ca' ? t('item_Remarks') : ''} />;
};

export default E;
